export const NoPokemonFallback = () => {
  return (
    <div className="flex items-center w-full h-full">
      <div className="flex flex-col justify-center items-center gap-2 bg-pk-black/60 shadow-cartoon backdrop-blur-md p-4 border-pk-white border-b-2 rounded-xl w-full">
        <span className="text-2xl">No Pokemon Selected</span>
        <button className="bg-pk-white px-4 py-2 rounded-md text-pk-black">
          Back
        </button>
      </div>
    </div>
  );
}